module.exports = __webpack_public_path__ + "img/squig3.9f1682a.png";